import PageHero from '@/components/PageHero';
import HowItWorks from '@/components/HowItWorks';
import TripleSection from '@/components/TripleSection';
import CTABanner from '@/components/CTABanner';
import s from '@/components/home.module.css';

const capabilities = [
  'Drafts pleadings, motions, briefs.',
  'Verifies every citation against primary sources.',
  'Tracks deadlines and court calendar.',
  'Assembles exhibits with cryptographic chain-of-custody.',
  'Keeps every matter with its attorney of record — nothing files without their signature.',
  'Surfaces the questions only an attorney can answer.',
];

export default function How() {
  return (
    <>
      <PageHero
        eyebrow="How it works"
        title="Court-ready, priced up front."
        sub="Your attorney runs their practice on AVOWAL: ELARIA does the operations work under the firm's own brand — so the price reflects the actual judgment, not the hours of paperwork."
      />

      <HowItWorks />

      <TripleSection
        id="scope"
        label="Limited scope, in practice"
        title="You pay for the judgment, not the hours."
        lead="Limited-scope is not 'limited service.' Flat-fee is not 'cheap' — it's predictable. Here is what that structure actually means for your matter."
        cards={[
          { num: '/ DEFINED', title: 'A task, not a retainer', body: 'You engage an attorney for a specific, bounded task — a motion, a hearing, a contract review — with the scope written down and court-approved where required. No open-ended meter.' },
          { num: '/ PRICED', title: 'A quote before you commit', body: "ELARIA scopes the work and prepares a flat-fee estimate up front, anchored to the firm's published rates. The attorney confirms the number before you commit — and before the clock starts on the work." },
          { num: '/ VISIBLE', title: 'Every step on the record', body: 'You see every document, every citation, and every audit trail as the matter moves. Nothing happens behind a billing curtain.' },
        ]}
      />

      <section>
        <div className="container">
          <span className={s.sectionLabel}>What ELARIA does</span>
          <h2 className={s.sectionTitle}>The mechanical layer, automated.</h2>
          <ul className={s.capList}>
            {capabilities.map((c) => (
              <li key={c} className={s.capItem}>{c}</li>
            ))}
          </ul>
        </div>
      </section>

      <CTABanner />
    </>
  );
}
